import * as React from 'react';
import StyledLineChart from "../chart/StyledLineChart";
import ChartOptions from "../chart/ChartOptions";
import StyledStackedBarChart from "../chart/StyledStackedBarChart";
import StyledDoughnutChart from "../chart/StyledDoughnutChart";
import {TableComponent} from "oca-lib-web";
import { TagCloud } from 'react-tagcloud';
import Constants from "./Constants";
import MessageResources from "./MessageResources";
import moment from "moment";

export default class GraphFactory {

    public static create(graphSettings:GraphSettings, dataset:any, onRowSelection:any) {
        return (
            graphSettings.chartType == Constants.CHART_TYPE_LINE ? this.renderLineChart(graphSettings, dataset, onRowSelection) :
                graphSettings.chartType == Constants.CHART_TYPE_BAR ? this.renderBarChart(graphSettings, dataset, onRowSelection) :
                    graphSettings.chartType == Constants.CHART_TYPE_DONUT ? this.renderDonutChart(graphSettings, dataset) :
                        graphSettings.chartType == "listTable" ? this.renderTable(graphSettings, dataset, onRowSelection) :
                            graphSettings.chartType == "geo" ? this.renderGeo(graphSettings, dataset) :
                                graphSettings.chartType == Constants.CHART_TYPE_WORDCLOUD ? this.renderWordCloud(graphSettings, dataset) : null
        )
    }

    private static renderBarChart(graphSettings:GraphSettings, dataset:any, onRowSelection:any) {
        return <StyledStackedBarChart
            data={dataset.data}
            options={ChartOptions.StackedBarChartOptions(graphSettings, onRowSelection)}
            height={250}
            redraw
        />
    }

    private static renderDonutChart(graphSettings:GraphSettings, dataset:any) {
        return <StyledDoughnutChart
            data={dataset.data}
            options={ChartOptions.DoughnutChartOptions(graphSettings)}
            height={250}
            redraw
        />
    }

    private static renderLineChart(graphSettings:GraphSettings, dataset:any, onRowSelection:any) {
        return <StyledLineChart
            data={dataset.data}
            options={ChartOptions.LineChartOptions(graphSettings, onRowSelection)}
            height={250}
            redraw />
    }

    private static getTableHeaders(keys:Array<string>) {
        let headers = [];
        for (let key of keys) {
            headers.push(MessageResources.getText(key));
        }
        return headers;
    }

    private static renderTable(graphSettings:GraphSettings, dataset:any, onRowSelection:any) {
        return <TableComponent headers={this.getTableHeaders(Object.keys(dataset[0]))}
                               rows={dataset}
                               selectable={true}
                               onRowSelection={(e:any, data:any) => onRowSelection(data)}
                               resultsPerPage={5}
                               fitToContent={false}
                               getRow={this.renderReportRow.bind(this)}/>
    }

    public static renderWordCloud(graphSettings:GraphSettings, datset:any) {
        return <TagCloud
            minSize={8}
            maxSize={35}
            tags={datset}
            onClick={(tag:any) => alert(`'${tag.value}' was selected!`)}
        />
    }

    public static renderGeo(graphSettings:GraphSettings, dataset:any) {
        return <img src={this.getMapUri()} />
    }

    public static getMapUri() {
        return "https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/-78.638992,35.776791,9.67,0.00,0.00/500x250?access_token=pk.eyJ1IjoiZW1hamV3aWN6IiwiYSI6Ik5OX1JMREEifQ.E0AZQz9prc9zDkPVTE7IKQ"
    }

    private static renderReportRow(item:any) {
        let columns = [];
        let keys = Object.keys(item);
        for (let key of keys) {
            if (key == "date") {
                columns.push(moment(item[key], "YYYYMMDD").format("MM/DD/YYYY"));
            } else {
                columns.push(item[key]);
            }
        }
        return columns;
    }
}